/*
  OBSI – <obsi-wm-explorer>
  Client-side filter/search over the WM country cards (instant, no network).
  Fills flag emojis from a 2-letter ISO country code (zero-asset).
  Progressive reveal: shows `data-initial` cards first; the "Alle anzeigen"
  button reveals the rest. Filtering/searching always shows every match.
*/
if (!customElements.get('obsi-wm-explorer')) {
  customElements.define(
    'obsi-wm-explorer',
    class ObsiWmExplorer extends HTMLElement {
      connectedCallback() {
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-country]'));
        this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-filter]'));
        this.search = this.querySelector('[data-wm-search]');
        this.emptyEl = this.querySelector('[data-wm-empty]');
        this.showAllBtn = this.querySelector('[data-wm-showall]');
        this.moreCountEl = this.querySelector('[data-wm-more-count]');
        this.initial = parseInt(this.getAttribute('data-initial') || '0', 10) || 0;
        this.expanded = false;
        this.filter = 'all';
        this.query = '';

        this.fillFlags();

        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => {
            this.filter = chip.dataset.filter;
            this.chips.forEach((c) => {
              var active = c === chip;
              c.classList.toggle('is-active', active);
              c.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            this.apply();
          });
        });

        if (this.search) {
          this.search.addEventListener('input', () => {
            this.query = this.search.value.trim().toLowerCase();
            this.apply();
          });
        }

        if (this.showAllBtn) {
          this.showAllBtn.addEventListener('click', () => {
            this.expanded = true;
            this.apply();
            // Move focus to the first newly revealed card for keyboard users.
            var firstHidden = this.cards[this.initial];
            if (firstHidden) firstHidden.focus({ preventScroll: true });
          });
        }

        this.apply();
      }

      fillFlags() {
        this.querySelectorAll('[data-cc]').forEach(function (el) {
          var cc = (el.dataset.cc || '').toUpperCase();
          if (cc.length === 2 && /^[A-Z]{2}$/.test(cc)) {
            el.textContent = String.fromCodePoint(
              127397 + cc.charCodeAt(0),
              127397 + cc.charCodeAt(1)
            );
          }
        });
      }

      apply() {
        // Limit only the pristine view (no filter, no search, not yet expanded).
        var limited = !this.expanded && this.filter === 'all' && !this.query && this.initial > 0;
        // Once the user interacts, force-reveal so cards never stay at opacity:0.
        var forceReveal = this.expanded || this.filter !== 'all' || !!this.query;
        var matchCount = 0;
        var shown = 0;

        for (var i = 0; i < this.cards.length; i++) {
          var card = this.cards[i];
          var matchFilter = this.filter === 'all' || card.dataset.confederation === this.filter;
          var matchQuery = !this.query || (card.dataset.country || '').indexOf(this.query) > -1;
          var match = matchFilter && matchQuery;
          var visible = match;
          if (match) {
            matchCount++;
            if (limited && matchCount > this.initial) visible = false;
          }
          card.hidden = !visible;
          if (visible && forceReveal) card.classList.add('is-visible');
          if (visible) shown++;
        }

        if (this.emptyEl) this.emptyEl.hidden = matchCount !== 0;

        if (this.showAllBtn) {
          var hasMore = limited && matchCount > shown;
          this.showAllBtn.hidden = !hasMore;
          if (hasMore && this.moreCountEl) this.moreCountEl.textContent = matchCount;
        }
      }
    }
  );
}
